<template>
    <div>
        <form-loader v-if="loading" message="Laden..."/>
        <template v-if="!loading">
            <b-row>
                <b-col>
                    <p>
                      Met uw inschrijving in WoningNet stadsregio Amsterdam, kunt u de daar opgebouwde rechten, ook inzetten voor Woonmatch Waterland.
                    </p>
                    <h2>Hoe haalt u uw opgebouwde rechten over</h2>
                    <p>
                      Met uw WoningNet gebruikersnaam (inschrijfnummer of het emailadres waarmee u bij WoningNet stadsregio Amsterdam staat ingeschreven), haalt u uw opgebouwde zoekrechten over.
                    </p>
                    <p>
                      U koppelt uw inschrijving aan Woonmatch Waterland door hieronder uw Woningnet gebruikersnaam in te vullen. Daarna drukt u op “koppeling starten”. Als uw gebruikersnaam bij WoningNet bekend is, ontvangt u van WoningNet een email met de vervolgstappen.
                    </p>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" class="spacer d-none d-sm-block">&nbsp;</b-col>
            </b-row>
            <b-row>
                <b-col>
                    <h3>
                        <strong>Uw huidige status</strong>:
                    </h3>
                    <b-alert v-if="data.status === 'rejected'" variant="danger" show>
                      U heeft uw WoningNet inschrijving proberen te koppelen maar dit is niet gelukt omdat uw gegevens in WoningNet en Woonmatch niet exact gelijk zijn.<br/>
                      Controleer het nogmaals.
                    </b-alert>
                    <b-alert v-else-if="data.status === 'pending'" show>
                        U heeft een koppeling aangevraagd, maar deze is nog niet verwerkt. <br/>
                        U ontvangt een e-mail van WoningNet Stadsregio Amsterdam met de vervolgstappen.
                    </b-alert>
                    <b-alert v-else-if="data.status === 'confirmed'" variant="success" show>
                        Uw WoningNet inschrijving is gekoppeld aan Woonmatch Waterland. <br/>
                        U maakt nu gebruik van uw optimale zoekdatum.
                    </b-alert>
                    <b-alert v-else show>
                        U heeft nog geen gekoppelde Woningnet inschrijving
                    </b-alert>
                </b-col>
            </b-row>
            <div v-if="data.status === 'confirmed'">
                <b-row>
                    <b-col sm="12" class="spacer d-none d-sm-block">&nbsp;</b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <h3>
                            <strong>Uw WoningNet inschrijfnummer</strong>:
                        </h3>
                        <span>
                            {{data.data.wnUsername}}
                        </span>
                    </b-col>
                </b-row>

            </div>
            <div v-else-if="data.status !== 'pending'">
                <b-row>
                    <b-col>
                        <hr/>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="11" class="form-label">
                        <label for="dob">Woningnet Gebruikersnaam</label>
                    </b-col>
                    <b-col sm="11">
                        <b-form-input
                                id="wnUsername"
                                size="sm"
                                value=""
                                placeholder=""
                                v-model="form.wnUsername"
                        />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="12" class="spacer d-none d-sm-block">&nbsp;</b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-button variant="success" size="sm" class="mr-2 text-center pull-right" @click.stop="getWNData">
                            Koppeling starten
                        </b-button>
                    </b-col>
                </b-row>
            </div>

            <error-box v-if="postErrors.length > 0" :errors="postErrors"/>
        </template>
    </div>
</template>

<script>
    import FormButtons from '@/components/_registration/FormButtons'
    import ErrorBox from '@/components/_registration/ErrorBox'
    import FormLoader from '@/components/_registration/FormLoader'
    import dateTransformers from '@/mixins/dateTransformers'
    import { registrationService } from '@/_services/registration.service'

    export default {
        components: { FormButtons, ErrorBox, FormLoader },
        mixins: [dateTransformers],
        data: () => {
            return {
                data: {
                    status: 'noConnection',
                    data: {
                      wnUsername: '',
                      dateRequested: '',
                      dateConfirmed: '',
                      viaPartner: ''
                    }
                },
                postErrors: false,
                loading: false,
                form: {

                    wnUsername: '',
                },
                activeInput: ''
            }
        },
        name: 'Wn',
        mounted() {
            this.$emit('validated', true)
            this.getData()
        },
        activated () {

        },
        methods: {
            getData() {
                registrationService.getWN().then((data) => {
                    this.data = data
                    this.loading = false
                });
            },
            next () {
                this.submit()
            },
            submit () {

            },
            getWNData() {
                this.loading = true
                registrationService.postWN(this.form.wnUsername).then((data, err) => {
                    this.getData()
                })
            }
        }
    }
</script>

<style scoped>

</style>